import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="video-upload-mode"
export default class extends Controller {
  static targets = ["disabledOverlay", "videoUrl", "fileUpload", "dropzone", "fileSelectButton"]
  static classes = ["fileUploadDisabled", "videoUrlDisabled", "disabledOverlayHidden"]

  connect() {
    this.checkVideoUrl()
    this.checkFileUpload()
  }

  checkVideoUrl() {
    const hasVideoUrl = this.videoUrlTarget.value

    this.fileUploadTarget.disabled = hasVideoUrl

    if (hasVideoUrl) {
      this.dropzoneTarget.classList.add(...this.fileUploadDisabledClasses)
    } else {
      this.dropzoneTarget.classList.remove(...this.fileUploadDisabledClasses)
    }

    this.disabledOverlayTarget.classList.toggle(this.disabledOverlayHiddenClass, !hasVideoUrl)
  }

  checkFileUpload() {
    const hasFile = this.fileUploadTarget.files && this.fileUploadTarget.files.length > 0

    this.videoUrlTarget.disabled = hasFile
    this.videoUrlTarget.classList.toggle(this.grayClass, hasFile)
  }

  handleVideoUrlInput() {
    this.videoUrlTarget.value = this.videoUrlTarget.value.trim()
    this.checkVideoUrl()
  }

  handleFileChange() {
    this.checkFileUpload()
  }
}
